import Link from "next/link";
import { twMerge } from "tailwind-merge";

export function ButtonLink({
  children,
  href,
  external,
  className,
}: {
  children: React.ReactNode;
  href: string;
  external: boolean;
  className?: string;
}) {
  if (external) {
    return (
      <a
        href={href}
        className={twMerge(
          "inline-block rounded-lg bg-gradient-to-r from-gray-800 via-primary to-gray-800 bg-[size:200%_auto] px-6 py-3 text-center text-sm font-medium text-white backdrop-blur-2xl transition-all hover:bg-[right_center] lg:py-4",
          className
        )}
        target="_blank"
      >
        {children}
      </a>
    );
  } else {
    return (
      <Link
        className={twMerge(
          "rounded-lg bg-gradient-to-r from-gray-800 via-primary to-gray-800 bg-[size:200%_auto] px-6 py-3 text-center text-sm font-medium text-white backdrop-blur-2xl transition-all hover:bg-[right_center] lg:py-4",
          className
        )}
        href={href}
      >
        {children}
      </Link>
    );
  }
}
